'use client';

import { c as _c } from "react/compiler-runtime";
import type { ScrollableElement } from 'src/types/scrollbars';
import type { CSSObject, Theme } from '@mui/material/styles';
import MuiDrawer from '@mui/material/Drawer';
import type React from 'react';
import { DRAWER_WIDTH, DRAWER_WIDTH_CLOSED } from 'src/constants/styles';
import { styled } from '@mui/material/styles';
import { SizingProps } from 'src/types/sizing';
import { shouldForwardProp } from 'src/components/Particles/Particles';
import { sizingCustomProps, sizingMixin } from 'src/components/Particles/Sizing';
import { scrollbarCustomProps, scrollbarMixin } from 'src/components/Particles/Scrollbars';
type DrawerProps = SizingProps & ScrollableElement & {
  open?: boolean;
  children: React.ReactNode;
};

// todo: Move these to transition particles
const openedMixin = (theme: Theme): CSSObject => ({
  overflowX: 'hidden',
  width: `${DRAWER_WIDTH}px`,
  transition: theme.transitions.create('width', {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.enteringScreen
  }),
  '& .MuiDrawer-paper': {
    width: `${DRAWER_WIDTH}px`,
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen
    })
  }
});
const closedMixin = (theme: Theme): CSSObject => ({
  overflowX: 'hidden',
  width: `${DRAWER_WIDTH_CLOSED}px`,
  transition: theme.transitions.create('width', {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen
  }),
  [theme.breakpoints.up('sm')]: {
    width: `${DRAWER_WIDTH_CLOSED}px`
  },
  '& .MuiDrawer-paper': {
    width: `${DRAWER_WIDTH_CLOSED}px`
  }
});
const StyledDrawerCreate = styled(MuiDrawer, {
  ...shouldForwardProp(['open', ...sizingCustomProps, ...scrollbarCustomProps])
});
const StyledDrawer = StyledDrawerCreate(({
  theme,
  ...props
}) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
  alignSelf: 'stretch',
  overflow: 'hidden',
  height: sizingMixin({
    screenHeight: true
  }).height,
  '& .MuiDrawer-paper': {
    ...scrollbarMixin({
      theme,
      ...props
    }),
    gap: theme.sizes.spacing['09'],
    paddingTop: theme.sizes.spacing['09'],
    backgroundColor: theme.colors.surface.brand,
    //   width: `${DRAWER_WIDTH}px`,
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen
    })
  },
  variants: [{
    props: ({
      open
    }) => open,
    style: {
      ...openedMixin(theme)
    }
  }, {
    props: ({
      open
    }) => !open,
    style: {
      ...closedMixin(theme)
    }
  }]
}));
const Drawer: React.FC<DrawerProps> = t0 => {
  const $ = _c(8);
  let children;
  let props;
  let t1;
  if ($[0] !== t0) {
    ({
      children,
      open: t1,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = props;
    $[3] = t1;
  } else {
    children = $[1];
    props = $[2];
    t1 = $[3];
  }
  const open = t1 === undefined ? true : t1;
  let t2;
  if ($[4] !== children || $[5] !== open || $[6] !== props) {
    t2 = <StyledDrawer variant="permanent" className="inverted" open={open} {...props}>{children}</StyledDrawer>;
    $[4] = children;
    $[5] = open;
    $[6] = props;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  return t2;
};
export default Drawer;
export type { DrawerProps };